import styled from 'styled-components';

export const LogOutHeader = styled.div`
position:static;
margin-top:23px;
margin-left:4%;
font-family: Nunito;
font-style: normal;
font-weight: 600;
font-size: 16px;
line-height: 14px;
display: flex;
color: #303645;
`;

export const LogOutBtnGrp = styled.div`
position:static;
margin-top:35px;
height:48px;
width:92%;
display:flex;
flex-direction:row;
justify-content:space-between;
box-sizing:border-box;
margin-left:4%;
`;

export const YesBtn = styled.button`
position:static;
width:48%;
height:100%;
outline:none;
background: #FFFFFF;
border: 2px solid #E1E5EE;
font-family: Nunito;
font-style: normal;
font-weight: bold;
font-size: 16px;
line-height: 140%;
color: #828999;
`;

export const NoBtn = styled(YesBtn)`
background: #454ADE;
color:#FFFF;
border-radius: 4px;
border:none;
`;